// import type { ImageViewModel } from "@/src/shared/presentation/view-models/image-view-model";
import { FileFieldViewModel } from '@/src/shared/presentation/view-models/file-field.viewModel';

import type { CMSMenuItem } from '@/src/cms/domain/models/cms-menu';

export class CMSMenuItemViewModel {
  enabled: boolean;

  title: string;

  url: string;

  fieldMenuIcon?: FileFieldViewModel;

  below: CMSMenuItemViewModel[];

  constructor(data: Partial<CMSMenuItemViewModel>) {
    this.enabled = data.enabled ?? true;
    this.title = data.title || '';
    this.url = data.url || '';
    this.fieldMenuIcon = data.fieldMenuIcon;
    this.below = data.below || [];
  }

  static presenter(entity: CMSMenuItem): CMSMenuItemViewModel {
    return new CMSMenuItemViewModel({
      enabled: entity.enabled,
      title: entity.title,
      url: entity.url,
      fieldMenuIcon: entity.fieldMenuIcon && FileFieldViewModel.presenter(entity.fieldMenuIcon),
      below: entity.below.map(CMSMenuItemViewModel.presenter)
    });
  }
}
